<template>
  <div class="container page">
    <van-nav-bar :title="$t('my.task_record')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>

    <div class="main">

      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
        :pulling-text="$t('video.pull_down')"
        :loosing-text="$t('video.release')"
        :loading-text="$t('video.refreshing')"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="list.length ? $t('common.no_more') : ''"
          :loading-text="$t('loading')"
          :immediate-check="false"
          @load="onLoad"
        >
          <van-empty v-if="list.length === 0 && finished" :description="$t('withdraw.empty_data')" />
        <div class="item_list" v-for="(v,key) in list" :key="key" @click="showDetail(v)">
          <div class="lottery_info">
            <van-image class="cover" :src="v.ico || '/img/error.png'">
              <template v-slot:loading>
                <van-loading type="spinner"/>
              </template>
              <template v-slot:error>
                <img src="/img/error.png" style="width: 100%; height: 100%; object-fit: cover;" alt="error" />
              </template>
            </van-image>
            <span class="period-number">{{v.expect}}</span>
            <span class="period-number">{{v.name}}</span>
          </div>
          <div class="recent">
            <div class="kuaisan-ball left">
            <div>
              <span>{{$t("reservation.result")}}</span>
              <span class="ressquareBox">{{ getSize(v) }}</span>
              <span class="ressquareBox">{{ getDouble(v) }}</span>
            </div>
            </div>
          </div>
          <div class="topInfo">
            <span v-if="v.status === 1" style="color: #07c160">{{v.status_text}}</span>
            <span v-else>{{v.status_text}}</span>
            <span>{{$t("reservation.money")}}：{{v.money}}</span>
          </div>
          <div class="time">
            <span>{{$t("reservation.order_time")}}：{{v.create_time | time12}}</span>
          </div>
          <div class="time">
            <span>{{$t("reservation.settle_time")}}：{{v.update_time | time12}}</span>
          </div>
        </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <!-- 订单详情弹窗 -->
    <van-popup v-model="showPopup" position="bottom" round :style="{ maxHeight: '80%' }">
      <div class="detail-popup" v-if="currentItem">
        <div class="detail-header">
          <span>{{ $t('game_record.order_detail') }}</span>
          <van-icon name="cross" @click="showPopup = false" />
        </div>
        <div class="detail-content">
          <!-- 订单总览 -->
          <div class="detail-section">
            <div class="detail-row">
              <span class="label">{{ $t('game_record.game_name') }}</span>
              <span class="value">{{ currentItem.name }}</span>
            </div>
            <div class="detail-row">
              <span class="label">{{ $t('reservation.num') }}</span>
              <span class="value">{{ currentItem.expect }}</span>
            </div>
            <div class="detail-row">
              <span class="label">{{ $t('game_record.bet_count') }}</span>
              <span class="value">{{ currentItem.count }}</span>
            </div>
            <div class="detail-row">
              <span class="label">{{ $t('game_record.total_money') }}</span>
              <span class="value">{{ currentItem.money }}</span>
            </div>
            <div class="detail-row" v-if="currentItem.opencode && currentItem.opencode.length">
              <span class="label">{{ $t('game_record.lottery_result') }}</span>
              <span class="value lottery-result">
                <span class="result-tag">{{ getSize(currentItem) }}</span>
                <span class="result-tag">{{ getDouble(currentItem) }}</span>
              </span>
            </div>
            <div class="detail-row">
              <span class="label">{{ $t('game_record.order_profit') }}</span>
              <span class="value profit-value" :class="getTotalProfitClass(currentItem)">
                {{ getTotalProfit(currentItem) }}
              </span>
            </div>
            <div class="detail-row">
              <span class="label">{{ $t('reservation.order_time') }}</span>
              <span class="value">{{ currentItem.create_time | time12 }}</span>
            </div>
            <div class="detail-row">
              <span class="label">{{ $t('reservation.settle_time') }}</span>
              <span class="value">{{ currentItem.update_time | time12 }}</span>
            </div>
          </div>

          <!-- 投注明细 -->
          <div class="detail-section" v-if="currentItem.data && currentItem.data.length">
            <div class="section-title">{{ $t('game_record.bet_detail') }}</div>
            <div class="bet-item" v-for="(bet, index) in currentItem.data" :key="index">
              <div class="bet-row">
                <span class="label">{{ $t('game_record.bet_option') }}</span>
                <span class="value">{{ formatBetType(bet.type) }}</span>
              </div>
              <div class="bet-row">
                <span class="label">{{ $t('game_record.amount') }}</span>
                <span class="value">{{ bet.money }}</span>
              </div>
              <div class="bet-row">
                <span class="label">{{ $t('game_record.odds') }}</span>
                <span class="value">{{ bet.peilv }}</span>
              </div>
              <div class="bet-row">
                <span class="label">{{ $t('game_record.is_settled') }}</span>
                <span class="value" :style="{ color: bet.status === 1 ? '#07c160' : '#ff976a' }">{{ bet.status_text }}</span>
              </div>
              <div class="bet-row">
                <span class="label">{{ $t('game_record.win_lose') }}</span>
                <span class="value" :style="{ color: bet.is_win === 1 ? '#07c160' : '#ee0a24' }">{{ bet.win_text || '-' }}</span>
              </div>
              <div class="bet-row">
                <span class="label">{{ $t('game_record.profit') }}</span>
                <span class="value" :style="{ color: bet.profit > 0 ? '#07c160' : (bet.profit < 0 ? '#ee0a24' : '#666') }">
                  {{ bet.profit !== null ? bet.profit : '-' }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      list: [],
      page: 1,
      pageSize: 10,
      showPopup: false,
      currentItem: null
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    onRefresh() {
      this.page = 1;
      this.list = [];
      this.finished = false;
      this.getUserGameList();
    },
    onLoad() {
      this.getUserGameList();
    },
    showDetail(item) {
      this.currentItem = item;
      this.showPopup = true;
    },
    formatBetType(type) {
      const typeMap = {
        big: this.$t('lottery.rose'),
        small: this.$t('lottery.lily'),
        one: this.$t('lottery.fireworks'),
        two: this.$t('lottery.balloon')
      };
      return typeMap[type] || type;
    },
    getSum(item) {
      if (!item.opencode || !item.opencode.length) return 0;
      return item.opencode[0] + item.opencode[1] + item.opencode[2];
    },
    getSize(item) {
      const sum = this.getSum(item);
      if (sum >= 11 && sum <= 18) {
        return this.$t('lottery.rose');
      } else if (sum >= 3 && sum <= 10) {
        return this.$t('lottery.lily');
      }
      return '-';
    },
    getDouble(item) {
      const sum = this.getSum(item);
      if (sum % 2 === 0) {
        return this.$t('lottery.balloon');
      } else {
        return this.$t('lottery.fireworks');
      }
    },
    getTotalProfit(item) {
      if (!item.data || !item.data.length) return '-';
      let total = 0;
      let hasProfit = false;
      item.data.forEach(bet => {
        if (bet.profit !== null) {
          total += parseFloat(bet.profit) || 0;
          hasProfit = true;
        }
      });
      if (!hasProfit) return '-';
      return total > 0 ? '+' + total.toFixed(2) : total.toFixed(2);
    },
    getTotalProfitClass(item) {
      if (!item.data || !item.data.length) return '';
      let total = 0;
      item.data.forEach(bet => {
        if (bet.profit !== null) {
          total += parseFloat(bet.profit) || 0;
        }
      });
      if (total > 0) return 'profit-win';
      if (total < 0) return 'profit-lose';
      return '';
    },
    getUserGameList(){
      this.$http({
        method: 'get',
        url: 'user_get_game_list',
        data: { page: this.page, pageSize: this.pageSize }
      }).then(res=>{
        this.isLoading = false;
        this.loading = false;
        if(res.code === 200){
          const newList = res.data.list || res.data;
          this.list = this.page === 1 ? newList : [...this.list, ...newList];

          if (res.data.pagination) {
            this.finished = this.page >= res.data.pagination.totalPages;
          } else {
            this.finished = newList.length < this.pageSize;
          }
          this.page++;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      }).catch(() => {
        this.isLoading = false;
        this.loading = false;
      });
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    } else {
      this.getUserGameList();
    }
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}
.container .main{
  position: relative;
  overflow: auto;
  background-color: #f2f2f5;
  height: 100%;
  padding: 0 10px;
}
.item_list{
  padding: 15px 15px;
  margin: 30px 10px;
  background: #fff;
  border-radius: 10px;
  line-height: 60px;
}

.item_list .topInfo span{
  flex: 1;
  font-size: 32px;
  font-weight: 700;
  color: #000;
}
.item_list .time span{
  flex: 1;
  font-size: 25px;
  font-weight: 500;
  color: #000;
}
.item_list .desc span{
  font-size: 25px;
  font-weight: 700;
  color: #9b9b9b;
}
.item_list .cover{
  width: 60px;
  height: 60px;
  -o-object-fit: cover;
  object-fit: cover;
}
.item_list  .period-number{
  margin-left: 50px;
  margin-right: 10px;
  height: 50px;
  line-height: 60px;
  font-size: 35px;
  font-weight: 700;
  color: #000;
}
.item_list .lottery_info{
  display: flex;
}
.recent {
  display: flex;
  align-items: center;
  height: 100px;
}
.kuaisan-ball .left{
  justify-content: flex-start;
}
.kuaisan-ball{
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img{
  width: 70px;
  height: 70px;
  margin-right: 30px;
}
.kuaisan-ball .res-des{
  font-weight: 700;
  text-align: center;
  color: #000;
}
.kuaisan-ball .res-des.middle{
  width: 15%;
  font-size: 35px;
}
.ressquareBox{
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
    color: #fff;
    height: 7vw;
    line-height: 7vw;
    text-align: center;
    font-size: 3vw;
    font-weight: 700;
    border-radius: 16px;
    margin-left: 20px;
    padding:  13px 40px;
    min-width: 13vw;
}

/* 订单详情弹窗样式 */
.detail-popup {
  padding: 30px;
}
.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
  font-size: 36px;
  font-weight: 700;
  color: #333;
}
.detail-header .van-icon {
  font-size: 40px;
  color: #999;
}
.detail-content {
  padding-top: 20px;
}
.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid #f5f5f5;
  font-size: 28px;
}
.detail-row .label {
  color: #666;
}
.detail-row .value {
  color: #333;
  font-weight: 500;
  text-align: right;
  max-width: 60%;
  word-break: break-all;
}

/* 投注明细样式 */
.detail-section {
  margin-bottom: 20px;
}
.section-title {
  font-size: 30px;
  font-weight: 700;
  color: #333;
  padding: 20px 0;
  border-bottom: 2px solid #eee;
}
.bet-item {
  background: #f9f9f9;
  border-radius: 10px;
  padding: 15px;
  margin-top: 15px;
}
.bet-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  font-size: 26px;
}
.bet-row .label {
  color: #666;
}
.bet-row .value {
  color: #333;
  font-weight: 500;
}

/* 开奖结果样式 */
.lottery-result {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.opencode {
  color: #333;
  font-weight: 600;
}
.result-tag {
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
  color: #fff;
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 22px;
}

/* 盈亏样式 */
.profit-value {
  font-weight: 700;
  font-size: 32px;
}
.profit-win {
  color: #07c160 !important;
}
.profit-lose {
  color: #ee0a24 !important;
}
</style>
